import { useMemo } from 'react'
import md5 from 'md5'
import { useCustomer } from './customer/useCustomer'
import { COOKIE_NAME_JWT } from '../constants'
import { useCookiesByGroup } from './useCookiesByGroup'
import { useUserData } from '../providers/user/user-data'

export const useUserUniqueId = () => {
	const { isLoggedIn } = useUserData()
	const { email } = useCustomer()
	const [{ [COOKIE_NAME_JWT]: cookieJwt }] = useCookiesByGroup([COOKIE_NAME_JWT])

	return useMemo(
		() => (isLoggedIn && !email ? null : isLoggedIn ? md5(email) : cookieJwt ? md5(cookieJwt) : null),
		[isLoggedIn, email, cookieJwt]
	)
}
